export enum DialogType {
  AddressValidation,
  DuplicateCheck
}
